import MetadataRow from './MetadataRow';

export default MetadataRow;
